import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMove = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.6667 8.66667L12.6667 10.6667L10.6667 12.6667",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3333 10.6667L3.33333 10.6667",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.33333 6.66667L3.33333 4.66667L5.33333 2.66667",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.66667 4.66667H12.6667",
			stroke: "currentColor",
			strokeWidth: 1.5
		})
	]
});
export default SvgMove;
